import * as types from '../actions/types';

const schedules = (state = [], action) => {
	switch (action.type) {
		case types.LOAD_SCHEDULES:
			return [...action.payload];
		case types.SIGN_OUT:
			return [];
		default:
			return state;
	}
};

export default schedules;
